import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TimestampService } from 'services/timestamp.service';

@Injectable({
  providedIn: 'root',
})
export class ReqInterceptorPageUpdateService implements HttpInterceptor {
  private readonly timestampService: TimestampService;

  public constructor() {
    const timestampService = inject(TimestampService);

    this.timestampService = timestampService;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap(() => this.timestampService.updateTime()));
  }
}
